import actionConstants from '../constants/';
import { PAYOUT_LISTING_NO_RECORD_ERROR_CODE } from '../../lib/constants';

const defaultState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  errorMessage: '',
};

const addNewBeneficiaryState = {
  ...defaultState,
};

const beneficiaryListState = {
  ...defaultState,
};

const approveBeneficiaryState = {
  ...defaultState,
};

const rejectBeneficiaryState = {
  ...defaultState,
};

const getBeneficiaryByCodeState = {
  ...defaultState,
};

const addIndividualPayoutState = {
  ...defaultState,
};

const individualPayoutListState = {
  ...defaultState,
};

const cancelIndividualPayoutState = {
  ...defaultState,
};

const rescheduleIndividualPayoutState = {
  ...defaultState,
};

const deactivateBeneficiaryState = {
  ...defaultState,
};

const updatePayoutModuleStatusState = {
  ...defaultState,
};

const bulkPayoutListState = {
  ...defaultState,
};

const bulkPayoutFailedRecordsState = {
  ...defaultState,
};

const bulkBeneficiaryListState = {
  ...defaultState,
};

const overviewData = {
  pendingIndividualPayoutCount: 0,
  pendingSchduledPayoutCount: 0,
  pendingVerificationCount: 0,
  todayCashflow: {
    addedAmount: 0,
    debitedAmount: 0,
    balanceAmount: 0,
  },
  statusSummary: {},
  transactionSummary: [],
  isError: false,
};

const payoutAccountBalanceState = {
  balance: 0,
  accountNumber: '',
  branchCode: '',
  isLoading: false,
  isFailure: false,
  errorMessage: '',
};

const remitterAccountsListState = {
  ...defaultState,
};

const currentAccountsListState = {
  ...defaultState,
};

const upiAccountsListState = {
  ...defaultState,
};

const addRemitterAccountState = {
  ...defaultState,
};

const updateRemitterAccountState = {
  ...defaultState,
};

const activateCurrentAccountState = {
  ...defaultState,
};

const activateUpiAccountState = {
  ...defaultState,
};

const addCurrentAccountState = {
  ...defaultState,
};

const updateCurrentAccountState = {
  ...defaultState,
};

const addUpiAccountState = {
  ...defaultState,
};

const configureUpiCredentialsState = {
  ...defaultState,
};

const configureNEFTCredentialsState = {
  ...defaultState,
};

const configureIMPSCredentialsState = {
  ...defaultState,
};

const bankListState = {
  ...defaultState,
  data: [],
};

const merchantDetailsState = {
  ...defaultState,
  data: [],
};

const addPublicKeyState = {
  ...defaultState,
};

const merchantKycEntityTypesListState = {
  ...defaultState,
  data: [],
};

const getMerchantKycDetailsState = {
  ...defaultState,
  data: [],
};

const getPennyDropPendingCountState = {
  ...defaultState,
  data: [],
};

const getPayoutPendingCountState = {
  ...defaultState,
  data: {},
};

const updateMerchantKycDetailsState = {
  ...defaultState,
  data: [],
};

const commonBulkFileApproveRejectState = {
  ...defaultState,
};

const lowBalanceEmailAlertState = {
  ...defaultState,
};

const manageEmailAlertState = {
  ...defaultState,
};

const initialState = {
  addNewBeneficiaryState: { ...addNewBeneficiaryState },
  beneficiaryListState: { ...beneficiaryListState },
  approveBeneficiaryState: { ...approveBeneficiaryState },
  rejectBeneficiaryState: { ...rejectBeneficiaryState },
  getBeneficiaryByCodeState: { ...getBeneficiaryByCodeState },
  addIndividualPayoutState: { ...addIndividualPayoutState },
  individualPayoutListState: { ...individualPayoutListState },
  deactivateBeneficiaryState: { ...deactivateBeneficiaryState },
  bulkPayoutListState: { ...bulkPayoutListState },
  bulkPayoutFailedRecordsState: { ...bulkPayoutFailedRecordsState },
  updatePayoutModuleStatusState: { ...updatePayoutModuleStatusState },
  cancelIndividualPayoutState: { ...cancelIndividualPayoutState },
  rescheduleIndividualPayoutState: { ...rescheduleIndividualPayoutState },
  overviewData: { ...overviewData },
  payoutAccountBalanceState: { ...payoutAccountBalanceState },
  remitterAccountsListState: { ...remitterAccountsListState },
  currentAccountsListState: { ...currentAccountsListState },
  upiAccountsListState: { ...upiAccountsListState },
  addRemitterAccountState: { ...addRemitterAccountState },
  addCurrentAccountState: { ...addCurrentAccountState },
  updateCurrentAccountState: { ...updateCurrentAccountState },
  addUpiAccountState: { ...addUpiAccountState },
  configureUpiCredentialsState: { ...configureUpiCredentialsState },
  configureIMPSCredentialsState: { ...configureIMPSCredentialsState },
  configureNEFTCredentialsState: { ...configureNEFTCredentialsState },
  updateRemitterAccountState: { ...updateRemitterAccountState },
  activateCurrentAccountState: { ...activateCurrentAccountState },
  activateUpiAccountState: { ...activateUpiAccountState },
  bankListState: { ...bankListState },
  merchantDetailsState: { ...merchantDetailsState },
  addPublicKeyState: { ...addPublicKeyState },
  merchantKycEntityTypesListState: { ...merchantKycEntityTypesListState },
  getMerchantKycDetailsState: { ...getMerchantKycDetailsState },
  getPennyDropPendingCountState: { ...getPennyDropPendingCountState },
  getPayoutPendingCountState: { ...getPayoutPendingCountState },
  updateMerchantKycDetailsState: { ...updateMerchantKycDetailsState },
  bulkBeneficiaryListState: { ...bulkBeneficiaryListState },
  commonBulkFileApproveRejectState: { ...commonBulkFileApproveRejectState },
  lowBalanceEmailAlertState: { ...lowBalanceEmailAlertState },
  manageEmailAlertState: { ...manageEmailAlertState },
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function payoutsReducer(state = initialState, action) {
  switch (action.type) {
    case actionConstants.POST_ADD_NEW_BENEFICIARY_REQUEST:
      return {
        ...state,
        addNewBeneficiaryState: {
          ...state.addNewBeneficiaryState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };

    case actionConstants.POST_ADD_NEW_BENEFICIARY_SUCCESS:
      return {
        ...state,
        addNewBeneficiaryState: {
          ...state.addNewBeneficiaryState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          body: action.payload.body,
        },
      };

    case actionConstants.POST_ADD_NEW_BENEFICIARY_FAILURE:
      return {
        ...state,
        addNewBeneficiaryState: {
          ...state.addNewBeneficiaryState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body.errorCode,
          errorMessage: action.payload.body.errorMessage,
        },
      };

    case actionConstants.POST_ADD_NEW_BENEFICIARY_CLEAR:
      return {
        ...state,
        addNewBeneficiaryState,
      };

    case actionConstants.GET_BENEFICIARY_LIST_REQUEST:
      return {
        ...state,
        beneficiaryListState: {
          ...state.beneficiaryListState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };

    case actionConstants.GET_BENEFICIARY_LIST_SUCCESS:
      return {
        ...state,
        beneficiaryListState: {
          ...state.beneficiaryListState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          successMessage: action.payload.body.successMessage,
        },
      };

    case actionConstants.GET_BENEFICIARY_LIST_FAILURE:
      return {
        ...state,
        beneficiaryListState: {
          ...state.beneficiaryListState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body.errorCode,
          errorMessage: action.payload.body.errorMessage,
          data: [],
        },
      };

    case actionConstants.GET_BENEFICIARY_LIST_CLEAR:
      return {
        ...state,
        beneficiaryListState,
      };

    case actionConstants.POST_APPROVE_BENEFICIARY_REQUEST:
      return {
        ...state,
        approveBeneficiaryState: {
          ...state.approveBeneficiaryState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };

    case actionConstants.POST_APPROVE_BENEFICIARY_SUCCESS:
      return {
        ...state,
        approveBeneficiaryState: {
          ...state.approveBeneficiaryState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body.data,
          successMessage: action.payload.body.successMessage,
        },
      };

    case actionConstants.POST_APPROVE_BENEFICIARY_FAILURE:
      return {
        ...state,
        approveBeneficiaryState: {
          ...state.approveBeneficiaryState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body.errorCode,
          errorMessage: action.payload.body.errorMessage,
        },
      };

    case actionConstants.POST_APPROVE_BENEFICIARY_CLEAR:
      return {
        ...state,
        approveBeneficiaryState,
      };

    case actionConstants.POST_REJECT_BENEFICIARY_REQUEST:
      return {
        ...state,
        rejectBeneficiaryState: {
          ...state.rejectBeneficiaryState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };

    case actionConstants.POST_REJECT_BENEFICIARY_SUCCESS:
      return {
        ...state,
        rejectBeneficiaryState: {
          ...state.rejectBeneficiaryState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body.data,
          successMessage: action.payload.body.successMessage,
        },
      };

    case actionConstants.POST_REJECT_BENEFICIARY_FAILURE:
      return {
        ...state,
        rejectBeneficiaryState: {
          ...state.rejectBeneficiaryState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body.errorCode,
          errorMessage: action.payload.body.errorMessage,
        },
      };

    case actionConstants.POST_REJECT_BENEFICIARY_CLEAR:
      return {
        ...state,
        rejectBeneficiaryState,
      };

    case actionConstants.GET_BENEFICIARY_BY_BENEFICIARY_CODE_REQUEST:
      return {
        ...state,
        getBeneficiaryByCodeState: {
          ...state.getBeneficiaryByCodeState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
          data: '',
          successMessage: '',
        },
      };

    case actionConstants.GET_BENEFICIARY_BY_BENEFICIARY_CODE_SUCCESS:
      return {
        ...state,
        getBeneficiaryByCodeState: {
          ...state.getBeneficiaryByCodeState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body.data,
          successMessage: action.payload.body.successMessage,
        },
      };

    case actionConstants.GET_BENEFICIARY_BY_BENEFICIARY_CODE_FAILURE:
      return {
        ...state,
        getBeneficiaryByCodeState: {
          ...state.getBeneficiaryByCodeState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body.errorCode,
          errorMessage: action.payload.body.errorMessage,
        },
      };

    case actionConstants.GET_BENEFICIARY_BY_BENEFICIARY_CODE_CLEAR:
      return {
        ...state,
        getBeneficiaryByCodeState,
      };

    case actionConstants.POST_ADD_INDIVIDUAL_PAYOUT_REQUEST:
      return {
        ...state,
        addIndividualPayoutState: {
          ...state.addIndividualPayoutState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };

    case actionConstants.POST_ADD_INDIVIDUAL_PAYOUT_SUCCESS:
      return {
        ...state,
        addIndividualPayoutState: {
          ...state.addIndividualPayoutState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body.data,
          successMessage: action.payload.body.successMessage,
        },
      };

    case actionConstants.POST_ADD_INDIVIDUAL_PAYOUT_FAILURE:
      return {
        ...state,
        addIndividualPayoutState: {
          ...state.addIndividualPayoutState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body.errorCode,
          errorMessage:
            action.payload.body.code === '4109'
              ? 'No active UPI Account'
              : action.payload.body.message,
        },
      };

    case actionConstants.POST_ADD_INDIVIDUAL_PAYOUT_CLEAR:
      return {
        ...state,
        addIndividualPayoutState,
      };

    case actionConstants.GET_INDIVIDUAL_PAYOUTS_LIST_REQUEST:
      return {
        ...state,
        individualPayoutListState: {
          ...state.individualPayoutListState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };

    case actionConstants.GET_INDIVIDUAL_PAYOUTS_LIST_SUCCESS:
      return {
        ...state,
        individualPayoutListState: {
          ...state.individualPayoutListState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          body: action.payload.body,
          successMessage: action.payload.body.successMessage,
        },
      };

    case actionConstants.GET_INDIVIDUAL_PAYOUTS_LIST_FAILURE:
      return {
        ...state,
        individualPayoutListState: {
          ...state.individualPayoutListState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body.errorCode,
          errorMessage: action.payload.body.errorMessage,
          // No matching record found
          ...(action?.payload?.body?.errorCode ===
            PAYOUT_LISTING_NO_RECORD_ERROR_CODE && { body: {} }),
        },
      };

    case actionConstants.GET_INDIVIDUAL_PAYOUTS_LIST_CLEAR:
      return {
        ...state,
        individualPayoutListState,
      };

    case actionConstants.CANCEL_INDIVIDUAL_PAYOUT_REQUEST:
      return {
        ...state,
        cancelIndividualPayoutState: {
          ...state.cancelIndividualPayoutState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };

    case actionConstants.CANCEL_INDIVIDUAL_PAYOUT_SUCCESS:
      return {
        ...state,
        cancelIndividualPayoutState: {
          ...state.cancelIndividualPayoutState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body.data,
          successMessage: action.payload.body.successMessage,
        },
      };

    case actionConstants.CANCEL_INDIVIDUAL_PAYOUT_FAILURE:
      return {
        ...state,
        cancelIndividualPayoutState: {
          ...state.cancelIndividualPayoutState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body.errorCode,
          errorMessage: action.payload.body.errorMessage,
        },
      };

    case actionConstants.CANCEL_INDIVIDUAL_PAYOUT_CLEAR:
      return {
        ...state,
        cancelIndividualPayoutState,
      };

    case actionConstants.RESCHEDULE_INDIVIDUAL_PAYOUT_REQUEST:
      return {
        ...state,
        rescheduleIndividualPayoutState: {
          ...state.rescheduleIndividualPayoutState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };

    case actionConstants.RESCHEDULE_INDIVIDUAL_PAYOUT_SUCCESS:
      return {
        ...state,
        rescheduleIndividualPayoutState: {
          ...state.rescheduleIndividualPayoutState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body.data,
          successMessage: action.payload.body.successMessage,
        },
      };

    case actionConstants.RESCHEDULE_INDIVIDUAL_PAYOUT_FAILURE:
      return {
        ...state,
        rescheduleIndividualPayoutState: {
          ...state.rescheduleIndividualPayoutState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body.errorCode,
          errorMessage: action.payload.body.errorMessage,
        },
      };

    case actionConstants.RESCHEDULE_INDIVIDUAL_PAYOUT_CLEAR:
      return {
        ...state,
        rescheduleIndividualPayoutState,
      };

    case actionConstants.PUT_DEACTIVATE_BENEFICIARY_REQUEST:
      return {
        ...state,
        deactivateBeneficiaryState: {
          ...state.deactivateBeneficiaryState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };

    case actionConstants.PUT_DEACTIVATE_BENEFICIARY_SUCCESS:
      return {
        ...state,
        deactivateBeneficiaryState: {
          ...state.deactivateBeneficiaryState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body.data,
          successMessage: action.payload.body.successMessage,
        },
      };

    case actionConstants.PUT_DEACTIVATE_BENEFICIARY_FAILURE:
      return {
        ...state,
        deactivateBeneficiaryState: {
          ...state.deactivateBeneficiaryState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body.errorCode,
          errorMessage: action.payload.body.errorMessage,
        },
      };

    case actionConstants.PUT_DEACTIVATE_BENEFICIARY_CLEAR:
      return {
        ...state,
        deactivateBeneficiaryState,
      };

    case actionConstants.GET_BULK_PAYOUT_LIST_REQUEST:
      return {
        ...state,
        bulkPayoutListState: {
          ...state.bulkPayoutListState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };

    case actionConstants.GET_BULK_PAYOUT_LIST_SUCCESS:
      return {
        ...state,
        bulkPayoutListState: {
          ...state.bulkPayoutListState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          body: action.payload.body,
          successMessage: action.payload.body.successMessage,
        },
      };

    case actionConstants.GET_BULK_PAYOUT_LIST_FAILURE:
      return {
        ...state,
        bulkPayoutListState: {
          ...state.bulkPayoutListState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body.errorCode,
          errorMessage: action.payload.body.errorMessage,
          // No matching record found
          ...(action?.payload?.body?.errorCode ===
            PAYOUT_LISTING_NO_RECORD_ERROR_CODE && { body: {} }),
        },
      };

    case actionConstants.GET_BULK_PAYOUT_LIST_CLEAR:
      return {
        ...state,
        bulkPayoutListState,
      };

    case actionConstants.GET_BULK_PAYOUT_FAILED_RECORDS_REQUEST:
      return {
        ...state,
        bulkPayoutFailedRecordsState: {
          ...state.bulkPayoutFailedRecordsState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };

    case actionConstants.GET_BULK_PAYOUT_FAILED_RECORDS_SUCCESS:
      return {
        ...state,
        bulkPayoutFailedRecordsState: {
          ...state.bulkPayoutFailedRecordsState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          body: action.payload.body,
          successMessage: action.payload.body.successMessage,
        },
      };

    case actionConstants.GET_BULK_PAYOUT_FAILED_RECORDS_FAILURE:
      return {
        ...state,
        bulkPayoutFailedRecordsState: {
          ...state.bulkPayoutFailedRecordsState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body.errorCode,
          errorMessage: action.payload.body.errorMessage,
        },
      };

    case actionConstants.GET_BULK_PAYOUT_FAILED_RECORDS_CLEAR:
      return {
        ...state,
        bulkPayoutFailedRecordsState,
      };

    case actionConstants.GET_BULK_BENEFICIARY_LIST_REQUEST:
      return {
        ...state,
        bulkBeneficiaryListState: {
          ...state.bulkBeneficiaryListState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };

    case actionConstants.GET_BULK_BENEFICIARY_LIST_SUCCESS:
      return {
        ...state,
        bulkBeneficiaryListState: {
          ...state.bulkBeneficiaryListState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          body: action.payload.body,
          successMessage: action.payload.body.successMessage,
        },
      };

    case actionConstants.GET_BULK_BENEFICIARY_LIST_FAILURE:
      return {
        ...state,
        bulkBeneficiaryListState: {
          ...state.bulkBeneficiaryListState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body.errorCode,
          errorMessage: action.payload.body.errorMessage,
          // No matching record found
          ...(action?.payload?.body?.errorCode ===
            PAYOUT_LISTING_NO_RECORD_ERROR_CODE && { body: {} }),
        },
      };

    case actionConstants.GET_BULK_BENEFICIARY_LIST_CLEAR:
      return {
        ...state,
        bulkBeneficiaryListState,
      };

    case actionConstants.PUT_UPDATE_PAYOUT_MODULE_STATUS_REQUEST:
      return {
        ...state,
        updatePayoutModuleStatusState: {
          ...updatePayoutModuleStatusState,
          isLoading: true,
        },
      };

    case actionConstants.PUT_UPDATE_PAYOUT_MODULE_STATUS_SUCCESS:
      return {
        ...state,
        updatePayoutModuleStatusState: {
          ...updatePayoutModuleStatusState,
          isSuccess: true,
        },
      };

    case actionConstants.PUT_UPDATE_PAYOUT_MODULE_STATUS_FAILURE:
      return {
        ...state,
        updatePayoutModuleStatusState: {
          ...updatePayoutModuleStatusState,
          isFailure: true,
        },
      };
    case actionConstants.PUT_UPDATE_PAYOUT_MODULE_STATUS_CLEAR:
      return {
        ...state,
        updatePayoutModuleStatusState: {
          ...updatePayoutModuleStatusState,
        },
      };

    case actionConstants.GET_PAYOUT_OVERVIEW_PENDING_SUMMARY_REQUEST:
      return {
        ...state,
        overviewData: {
          ...state.overviewData,
          isError: false,
        },
      };

    case actionConstants.GET_PAYOUT_OVERVIEW_PENDING_SUMMARY_SUCCESS:
      return {
        ...state,
        overviewData: {
          ...state.overviewData,
          pendingIndividualPayoutCount:
            action?.payload?.body?.data?.pendingPayNowPayoutCount ??
            state.overviewData.pendingIndividualPayoutCount,
          pendingSchduledPayoutCount:
            action?.payload?.body?.data?.pendingPayLaterPayoutCount ??
            state.overviewData.pendingSchduledPayoutCount,
          pendingVerificationCount:
            action?.payload?.body?.data?.pendingVerificationCount ??
            state.overviewData.pendingVerificationCount,
          todayCashflow: {
            addedAmount:
              action?.payload?.body?.data?.todayCashflow?.addedAmount ??
              state.overviewData.todayCashflow.addedAmount,
            debitedAmount:
              action?.payload?.body?.data?.todayCashflow?.debitedAmount ??
              state.overviewData.todayCashflow.debitedAmount,
            balanceAmount:
              action?.payload?.body?.data?.todayCashflow?.balanceAmount ??
              state.overviewData.todayCashflow.balanceAmount,
          },
        },
      };

    case actionConstants.GET_PAYOUT_OVERVIEW_PENDING_SUMMARY_FAILURE:
      return {
        ...state,
        overviewData: {
          ...state.overviewData,
          isError: true,
        },
      };

    case actionConstants.GET_PAYOUT_OVERVIEW_STATUS_SUMMARY_REQUEST:
      return {
        ...state,
        overviewData: {
          ...state.overviewData,
          isError: false,
        },
      };

    case actionConstants.GET_PAYOUT_OVERVIEW_STATUS_SUMMARY_SUCCESS:
      return {
        ...state,
        overviewData: {
          ...state.overviewData,
          statusSummary: action.payload?.body?.data ?? {},
        },
      };

    case actionConstants.GET_PAYOUT_OVERVIEW_STATUS_SUMMARY_FAILURE:
      return {
        ...state,
        overviewData: {
          ...state.overviewData,
          isError: true,
        },
      };

    case actionConstants.GET_PAYOUT_OVERVIEW_TRANSACTION_SUMMARY_REQUEST:
      return {
        ...state,
        overviewData: {
          ...state.overviewData,
          isError: false,
        },
      };

    case actionConstants.GET_PAYOUT_OVERVIEW_TRANSACTION_SUMMARY_SUCCESS:
      return {
        ...state,
        overviewData: {
          ...state.overviewData,
          transactionSummary: Array.isArray(action.payload?.body?.data)
            ? action.payload.body.data
            : state.overviewData.transactionSummary,
        },
      };

    case actionConstants.GET_PAYOUT_OVERVIEW_TRANSACTION_SUMMARY_FAILURE:
      return {
        ...state,
        overviewData: {
          ...state.overviewData,
          isError: true,
        },
      };

    case actionConstants.CLEAR_PAYOUT_OVERVIEW_ERROR_STATE:
      return {
        ...state,
        overviewData: {
          ...state.overviewData,
          isError: false,
        },
      };

    case actionConstants.GET_PAYOUT_ACCOUNT_BALANCE_REQUEST:
      return {
        ...state,
        payoutAccountBalanceState: {
          ...state.payoutAccountBalanceState,
          isLoading: true,
          isFailure: false,
          errorMessage: '',
        },
      };

    case actionConstants.GET_PAYOUT_ACCOUNT_BALANCE_SUCCESS:
      return {
        ...state,
        payoutAccountBalanceState: {
          ...payoutAccountBalanceState,
          balance:
            action.payload?.body?.data?.balance ??
            state.payoutAccountBalanceState.balance,
          accountNumber:
            action.payload?.body?.data?.accountNumber ??
            state.payoutAccountBalanceState.accountNumber,
          branchCode:
            action.payload?.body?.data?.branchCode ??
            state.payoutAccountBalanceState.branchCode,
          isLoading: false,
        },
      };

    case actionConstants.GET_PAYOUT_ACCOUNT_BALANCE_FAILURE:
      return {
        ...state,
        payoutAccountBalanceState: {
          ...state.payoutAccountBalanceState,
          isLoading: false,
          isFailure: true,
          errorMessage: action.payload?.body?.errorMessage ?? '',
        },
      };

    case actionConstants.GET_PAYOUT_ACCOUNT_BALANCE_CLEAR:
      return {
        ...state,
        payoutAccountBalanceState,
      };

    case actionConstants.GET_PAYOUT_REMITTER_ACCOUNTS_LIST_REQUEST:
      return {
        ...state,
        remitterAccountsListState: {
          ...state.remitterAccountsListState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };

    case actionConstants.GET_PAYOUT_REMITTER_ACCOUNTS_LIST_SUCCESS:
      return {
        ...state,
        remitterAccountsListState: {
          ...state.remitterAccountsListState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          body: action.payload.body,
          successMessage: action.payload.body.successMessage,
        },
      };

    case actionConstants.GET_PAYOUT_REMITTER_ACCOUNTS_LIST_FAILURE:
      return {
        ...state,
        remitterAccountsListState: {
          ...state.remitterAccountsListState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body.errorCode,
          errorMessage: action.payload.body.errorMessage,
          // No matching record found
          ...(action?.payload?.body?.errorCode ===
            PAYOUT_LISTING_NO_RECORD_ERROR_CODE && { body: {} }),
        },
      };

    case actionConstants.GET_PAYOUT_REMITTER_ACCOUNTS_LIST_CLEAR:
      return {
        ...state,
        remitterAccountsListState,
      };

    case actionConstants.GET_PAYOUT_CURRENT_ACCOUNTS_LIST_REQUEST:
      return {
        ...state,
        currentAccountsListState: {
          ...state.currentAccountsListState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };

    case actionConstants.GET_PAYOUT_CURRENT_ACCOUNTS_LIST_SUCCESS:
      return {
        ...state,
        currentAccountsListState: {
          ...state.currentAccountsListState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          body: action.payload.body,
          successMessage: action.payload.body.successMessage,
        },
      };

    case actionConstants.GET_PAYOUT_CURRENT_ACCOUNTS_LIST_FAILURE:
      return {
        ...state,
        currentAccountsListState: {
          ...state.currentAccountsListState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body.errorCode,
          errorMessage: action.payload.body.errorMessage,
          // No matching record found
          ...(action?.payload?.body?.errorCode ===
            PAYOUT_LISTING_NO_RECORD_ERROR_CODE && { body: {} }),
        },
      };

    case actionConstants.GET_PAYOUT_CURRENT_ACCOUNTS_LIST_CLEAR:
      return {
        ...state,
        currentAccountsListState,
      };

    case actionConstants.GET_PAYOUT_UPI_ACCOUNTS_LIST_REQUEST:
      return {
        ...state,
        upiAccountsListState: {
          ...state.upiAccountsListState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };

    case actionConstants.GET_PAYOUT_UPI_ACCOUNTS_LIST_SUCCESS:
      return {
        ...state,
        upiAccountsListState: {
          ...state.upiAccountsListState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          body: action.payload.body,
          successMessage: action.payload.body.successMessage,
        },
      };

    case actionConstants.GET_PAYOUT_UPI_ACCOUNTS_LIST_FAILURE:
      return {
        ...state,
        upiAccountsListState: {
          ...state.upiAccountsListState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body.errorCode,
          errorMessage: action.payload.body.errorMessage,
          // No matching record found
          ...(action?.payload?.body?.errorCode ===
            PAYOUT_LISTING_NO_RECORD_ERROR_CODE && { body: {} }),
        },
      };

    case actionConstants.GET_PAYOUT_UPI_ACCOUNTS_LIST_CLEAR:
      return {
        ...state,
        upiAccountsListState,
      };

    case actionConstants.POST_ADD_PAYOUT_REMITTER_ACCOUNT_REQUEST:
      return {
        ...state,
        addRemitterAccountState: {
          ...state.addRemitterAccountState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };

    case actionConstants.POST_ADD_PAYOUT_REMITTER_ACCOUNT_SUCCESS:
      return {
        ...state,
        addRemitterAccountState: {
          ...state.addRemitterAccountState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          body: action.payload.body,
          successMessage: action.payload.body.successMessage,
        },
      };

    case actionConstants.POST_ADD_PAYOUT_REMITTER_ACCOUNT_FAILURE:
      return {
        ...state,
        addRemitterAccountState: {
          ...state.addRemitterAccountState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body.errorCode,
          errorMessage: action.payload.body.errorMessage,
        },
      };

    case actionConstants.POST_ADD_PAYOUT_REMITTER_ACCOUNT_CLEAR:
      return {
        ...state,
        addRemitterAccountState,
      };

    case actionConstants.POST_ADD_PAYOUT_CURRENT_ACCOUNT_REQUEST:
      return {
        ...state,
        addCurrentAccountState: {
          ...state.addCurrentAccountState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };

    case actionConstants.POST_ADD_PAYOUT_CURRENT_ACCOUNT_SUCCESS:
      return {
        ...state,
        addCurrentAccountState: {
          ...state.addCurrentAccountState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          body: action.payload.body,
          successMessage: action.payload.body.successMessage,
        },
      };

    case actionConstants.POST_ADD_PAYOUT_CURRENT_ACCOUNT_FAILURE:
      return {
        ...state,
        addCurrentAccountState: {
          ...state.addCurrentAccountState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body.errorCode,
          errorMessage: action.payload.body.errorMessage,
        },
      };

    case actionConstants.POST_ADD_PAYOUT_CURRENT_ACCOUNT_CLEAR:
      return {
        ...state,
        addCurrentAccountState,
      };
      
    case actionConstants.PUT_UPDATE_PAYOUT_CURRENT_ACCOUNT_REQUEST:
      return {
        ...state,
        updateCurrentAccountState: {
          ...state.updateCurrentAccountState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
        },
      };
      
    case actionConstants.PUT_UPDATE_PAYOUT_CURRENT_ACCOUNT_SUCCESS:
      return {
        ...state,
        updateCurrentAccountState: {
          ...state.updateCurrentAccountState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          successMessage: action?.payload?.data?.message,
        },
      };
      
    case actionConstants.PUT_UPDATE_PAYOUT_CURRENT_ACCOUNT_FAILURE:
      return {
        ...state,
        updateCurrentAccountState: {
          ...state.updateCurrentAccountState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorMessage: action?.payload?.message,
          errorCode: action?.payload?.code,
        },
      };
      
    case actionConstants.PUT_UPDATE_PAYOUT_CURRENT_ACCOUNT_CLEAR:
      return {
        ...state,
        updateCurrentAccountState,
      };

    case actionConstants.POST_ADD_PAYOUT_UPI_ACCOUNT_REQUEST:
      return {
        ...state,
        addUpiAccountState: {
          ...state.addUpiAccountState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };

    case actionConstants.POST_ADD_PAYOUT_UPI_ACCOUNT_SUCCESS:
      return {
        ...state,
        addUpiAccountState: {
          ...state.addUpiAccountState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          body: action.payload.body,
          successMessage: action.payload.body.successMessage,
        },
      };

    case actionConstants.POST_ADD_PAYOUT_UPI_ACCOUNT_FAILURE:
      return {
        ...state,
        addUpiAccountState: {
          ...state.addUpiAccountState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body.errorCode,
          errorMessage: action.payload.body.errorMessage,
        },
      };

    case actionConstants.POST_ADD_PAYOUT_UPI_ACCOUNT_CLEAR:
      return {
        ...state,
        addUpiAccountState,
      };

    case actionConstants.POST_UPDATE_PAYOUT_REMITTER_ACCOUNT_REQUEST:
      return {
        ...state,
        updateRemitterAccountState: {
          ...state.updateRemitterAccountState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };

    case actionConstants.POST_UPDATE_PAYOUT_REMITTER_ACCOUNT_SUCCESS:
      return {
        ...state,
        updateRemitterAccountState: {
          ...state.updateRemitterAccountState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          body: action.payload.body,
          successMessage: action.payload.body.successMessage,
        },
      };

    case actionConstants.POST_UPDATE_PAYOUT_REMITTER_ACCOUNT_FAILURE:
      return {
        ...state,
        updateRemitterAccountState: {
          ...state.updateRemitterAccountState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body.errorCode,
          errorMessage: action.payload.body.errorMessage,
        },
      };

    case actionConstants.POST_UPDATE_PAYOUT_REMITTER_ACCOUNT_CLEAR:
      return {
        ...state,
        updateRemitterAccountState,
      };

    case actionConstants.POST_ACTIVATE_PAYOUT_CURRENT_ACCOUNT_REQUEST:
      return {
        ...state,
        activateCurrentAccountState: {
          ...state.activateCurrentAccountState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };

    case actionConstants.POST_ACTIVATE_PAYOUT_CURRENT_ACCOUNT_SUCCESS:
      return {
        ...state,
        activateCurrentAccountState: {
          ...state.activateCurrentAccountState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          body: action.payload.body,
          successMessage: action.payload.body.successMessage,
        },
      };

    case actionConstants.POST_ACTIVATE_PAYOUT_CURRENT_ACCOUNT_FAILURE:
      return {
        ...state,
        activateUpiAccountState: {
          ...state.activateUpiAccountState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body.errorCode,
          errorMessage: action.payload.body.errorMessage,
        },
      };

    case actionConstants.POST_ACTIVATE_PAYOUT_CURRENT_ACCOUNT_CLEAR:
      return {
        ...state,
        activateUpiAccountState,
      };

    case actionConstants.POST_ACTIVATE_PAYOUT_UPI_ACCOUNT_REQUEST:
      return {
        ...state,
        activateUpiAccountState: {
          ...state.activateUpiAccountState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };

    case actionConstants.POST_ACTIVATE_PAYOUT_UPI_ACCOUNT_SUCCESS:
      return {
        ...state,
        activateUpiAccountState: {
          ...state.activateUpiAccountState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          body: action.payload.body,
          successMessage: action.payload.body.successMessage,
        },
      };

    case actionConstants.POST_ACTIVATE_PAYOUT_UPI_ACCOUNT_FAILURE:
      return {
        ...state,
        activateUpiAccountState: {
          ...state.activateUpiAccountState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body.errorCode,
          errorMessage: action.payload.body.errorMessage,
        },
      };

    case actionConstants.POST_ACTIVATE_PAYOUT_UPI_ACCOUNT_CLEAR:
      return {
        ...state,
        activateUpiAccountState,
      };

    case actionConstants.GET_MERCHANT_DETAILS_REQUEST:
      return {
        ...state,
        merchantDetailsState: {
          ...state.merchantDetailsState,
          isLoading: true,
          isFailure: false,
          isSuccess: false,
        },
      };

    case actionConstants.GET_MERCHANT_DETAILS_SUCCESS:
      return {
        ...state,
        merchantDetailsState: {
          ...merchantDetailsState,
          isSuccess: true,
          data: action.payload?.body?.data,
          isLoading: false,
        },
      };

    case actionConstants.GET_MERCHANT_DETAILS_FAILURE:
      return {
        ...state,
        merchantDetailsState: {
          ...merchantDetailsState,
          isFailure: true,
          isSuccess: false,
          isLoading: false,
          data: [],
        },
      };

    case actionConstants.GET_MERCHANT_DETAILS_CLEAR:
      return {
        ...state,
        merchantDetailsState: {
          ...merchantDetailsState,
        },
      };

    case actionConstants.POST_ADD_PUBLIC_KEY_REQUEST:
      return {
        ...state,
        addPublicKeyState: {
          ...state.addPublicKeyState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };

    case actionConstants.POST_ADD_PUBLIC_KEY_SUCCESS:
      return {
        ...state,
        addPublicKeyState: {
          ...state.addPublicKeyState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          body: action.payload.body,
          successMessage: action.payload.body.successMessage,
        },
      };

    case actionConstants.POST_ADD_PUBLIC_KEY_FAILURE:
      return {
        ...state,
        addPublicKeyState: {
          ...addPublicKeyState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body.errorCode,
          errorMessage:
            action.payload.body.errorDetails.length > 0
              ? action.payload.body.errorDetails[0].message
              : action.payload.body.errorMessage,
        },
      };

    case actionConstants.POST_ADD_PUBLIC_KEY_CLEAR:
      return {
        ...state,
        addPublicKeyState,
      };

    case actionConstants.GET_PAYOUT_BANK_LIST_REQUEST:
      return {
        ...state,
        bankListState: {
          ...state.bankListState,
          isLoading: true,
          isFailure: false,
          isSuccess: false,
        },
      };

    case actionConstants.GET_PAYOUT_BANK_LIST_SUCCESS:
      return {
        ...state,
        bankListState: {
          ...bankListState,
          isSuccess: true,
          bankList: action.payload?.body?.data?.banks,
          selectedBank: action.payload?.body?.data?.selectedBank,
          bankCode: action.payload?.body?.data?.bankCode,
          integrationType: action.payload?.body?.data?.integrationType,
          isLoading: false,
        },
      };

    case actionConstants.GET_PAYOUT_BANK_LIST_FAILURE:
      return {
        ...state,
        bankListState: {
          ...state.bankListState,
          isFailure: true,
          isSuccess: false,
          isLoading: false,
        },
      };

    case actionConstants.GET_PAYOUT_BANK_LIST_CLEAR:
      return {
        ...state,
        bankListState: {
          ...bankListState,
        },
      };

    case actionConstants.GET_MERCHANT_KYC_DETAILS_REQUEST:
      return {
        ...state,
        getMerchantKycDetailsState: {
          ...state.getMerchantKycDetailsState,
          isLoading: true,
          isFailure: false,
          isSuccess: false,
        },
      };

    case actionConstants.GET_MERCHANT_KYC_DETAILS_SUCCESS:
      return {
        ...state,
        getMerchantKycDetailsState: {
          ...state.getMerchantKycDetailsState,
          isSuccess: true,
          data: action.payload?.body?.data,
          isLoading: false,
        },
      };

    case actionConstants.GET_MERCHANT_KYC_DETAILS_FAILURE:
      return {
        ...state,
        getMerchantKycDetailsState: {
          ...state.getMerchantKycDetailsState,
          isFailure: true,
          isSuccess: false,
          isLoading: false,
          errorCode: action?.payload?.body?.errorCode,
          errorMessage: action?.payload?.body?.errorMessage,
        },
      };

    case actionConstants.GET_MERCHANT_KYC_DETAILS_CLEAR:
      return {
        ...state,
        getMerchantKycDetailsState: {
          ...getMerchantKycDetailsState,
        },
      };

    case actionConstants.GET_PENNY_DROP_PENDING_COUNT_REQUEST:
      return {
        ...state,
        getPennyDropPendingCountState: {
          ...state.getPennyDropPendingCountState,
          isLoading: true,
          isFailure: false,
          isSuccess: false,
        },
      };

    case actionConstants.GET_PENNY_DROP_PENDING_COUNT_SUCCESS:
      return {
        ...state,
        getPennyDropPendingCountState: {
          ...state.getPennyDropPendingCountState,
          isSuccess: true,
          data: action.payload?.body?.data,
          isLoading: false,
        },
      };

    case actionConstants.GET_PENNY_DROP_PENDING_COUNT_FAILURE:
      return {
        ...state,
        getPennyDropPendingCountState: {
          ...state.getPennyDropPendingCountState,
          isFailure: true,
          isSuccess: false,
          isLoading: false,
          errorCode: action?.payload?.body?.errorCode,
          errorMessage: action?.payload?.body?.errorMessage,
        },
      };

    case actionConstants.GET_PENNY_DROP_PENDING_COUNT_CLEAR:
      return {
        ...state,
        getPennyDropPendingCountState: {
          ...getPennyDropPendingCountState,
        },
      };

    case actionConstants.GET_PAYOUT_PENDING_COUNT_REQUEST:
      return {
        ...state,
        getPayoutPendingCountState: {
          ...state.getPayoutPendingCountState,
          isLoading: true,
          isFailure: false,
          isSuccess: false,
        },
      };

    case actionConstants.GET_PAYOUT_PENDING_COUNT_SUCCESS:
      return {
        ...state,
        getPayoutPendingCountState: {
          ...state.getPayoutPendingCountState,
          isSuccess: true,
          data:
            action.payload?.body?.data &&
            typeof action.payload?.body?.data === 'object' &&
            !Array.isArray(action.payload?.body?.data)
              ? action.payload?.body?.data
              : {},
          isLoading: false,
        },
      };

    case actionConstants.GET_PAYOUT_PENDING_COUNT_FAILURE:
      return {
        ...state,
        getPayoutPendingCountState: {
          ...state.getPayoutPendingCountState,
          isFailure: true,
          isSuccess: false,
          isLoading: false,
          errorCode: action?.payload?.body?.errorCode,
          errorMessage: action?.payload?.body?.errorMessage,
        },
      };

    case actionConstants.GET_PAYOUT_PENDING_COUNT_CLEAR:
      return {
        ...state,
        getPayoutPendingCountState: {
          ...getPayoutPendingCountState,
        },
      };

    case actionConstants.GET_MERCHANT_KYC_ENTITY_TYPES_LIST_REQUEST:
      return {
        ...state,
        merchantKycEntityTypesListState: {
          ...state.merchantKycEntityTypesListState,
          isLoading: true,
          isFailure: false,
          isSuccess: false,
        },
      };

    case actionConstants.GET_MERCHANT_KYC_ENTITY_TYPES_LIST_SUCCESS:
      return {
        ...state,
        merchantKycEntityTypesListState: {
          ...state.merchantKycEntityTypesListState,
          isSuccess: true,
          data: action.payload?.body?.data,
          isLoading: false,
        },
      };

    case actionConstants.GET_MERCHANT_KYC_ENTITY_TYPES_LIST_FAILURE:
      return {
        ...state,
        merchantKycEntityTypesListState: {
          ...state.merchantKycEntityTypesListState,
          isFailure: true,
          isSuccess: false,
          isLoading: false,
          errorCode: action?.payload?.body?.errorCode,
          errorMessage: action?.payload?.body?.errorMessage,
        },
      };

    case actionConstants.GET_MERCHANT_KYC_ENTITY_TYPES_LIST_CLEAR:
      return {
        ...state,
        merchantKycEntityTypesListState: {
          ...merchantKycEntityTypesListState,
        },
      };

    case actionConstants.POST_UPDATE_MERCHANT_KYC_DETAILS_REQUEST:
      return {
        ...state,
        updateMerchantKycDetailsState: {
          ...state.updateMerchantKycDetailsState,
          isLoading: true,
          isFailure: false,
          isSuccess: false,
        },
      };

    case actionConstants.POST_UPDATE_MERCHANT_KYC_DETAILS_SUCCESS:
      return {
        ...state,
        updateMerchantKycDetailsState: {
          ...state.updateMerchantKycDetailsState,
          isSuccess: true,
          data: action.payload?.body?.data,
          isLoading: false,
        },
      };

    case actionConstants.POST_UPDATE_MERCHANT_KYC_DETAILS_FAILURE:
      return {
        ...state,
        updateMerchantKycDetailsState: {
          ...state.updateMerchantKycDetailsState,
          isFailure: true,
          isSuccess: false,
          isLoading: false,
          errorCode: action?.payload?.body?.errorCode,
          errorMessage: action?.payload?.body?.errorMessage,
        },
      };

    case actionConstants.POST_UPDATE_MERCHANT_KYC_DETAILS_CLEAR:
      return {
        ...state,
        updateMerchantKycDetailsState: {
          ...updateMerchantKycDetailsState,
        },
      };

    case actionConstants.POST_COMMON_BULK_FILE_APPROVE_REJECT_REQUEST:
      return {
        ...state,
        commonBulkFileApproveRejectState: {
          ...state.commonBulkFileApproveRejectState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };

    case actionConstants.POST_COMMON_BULK_FILE_APPROVE_REJECT_SUCCESS:
      return {
        ...state,
        commonBulkFileApproveRejectState: {
          ...state.commonBulkFileApproveRejectState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body.data,
          successMessage: action.payload.body.successMessage,
        },
      };

    case actionConstants.POST_COMMON_BULK_FILE_APPROVE_REJECT_FAILURE:
      return {
        ...state,
        commonBulkFileApproveRejectState: {
          ...state.commonBulkFileApproveRejectState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body.errorCode,
          errorMessage: action.payload.body.errorMessage,
        },
      };

    case actionConstants.POST_COMMON_BULK_FILE_APPROVE_REJECT_CLEAR:
      return {
        ...state,
        commonBulkFileApproveRejectState,
      };

    case actionConstants.LOW_BALANCE_EMAIL_ALERT_REQUEST:
      return {
        ...state,
        lowBalanceEmailAlertState: {
          ...state.lowBalanceEmailAlertState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };

    case actionConstants.LOW_BALANCE_EMAIL_ALERT_SUCCESS:
      return {
        ...state,
        lowBalanceEmailAlertState: {
          ...state.lowBalanceEmailAlertState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body.data,
          successMessage: action.payload.body.successMessage,
        },
      };

    case actionConstants.LOW_BALANCE_EMAIL_ALERT_FAILURE:
      return {
        ...state,
        lowBalanceEmailAlertState: {
          ...state.lowBalanceEmailAlertState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body.errorCode,
          errorMessage: action.payload.body.errorMessage,
        },
      };

    case actionConstants.LOW_BALANCE_EMAIL_ALERT_CLEAR:
      return {
        ...state,
        lowBalanceEmailAlertState,
      };

    case actionConstants.MANAGE_EMAIL_ALERT_REQUEST:
      return {
        ...state,
        manageEmailAlertState: {
          ...state.manageEmailAlertState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };

    case actionConstants.MANAGE_EMAIL_ALERT_SUCCESS:
      return {
        ...state,
        manageEmailAlertState: {
          ...state.manageEmailAlertState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body.data,
          successMessage: action.payload.body.successMessage,
        },
      };

    case actionConstants.MANAGE_EMAIL_ALERT_FAILURE:
      return {
        ...state,
        manageEmailAlertState: {
          ...state.manageEmailAlertState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body.errorCode,
          errorMessage: action.payload.body.errorMessage,
        },
      };

    case actionConstants.MANAGE_EMAIL_ALERT_CLEAR:
      return {
        ...state,
        manageEmailAlertState,
      };

    default:
      return state;
  }
}
